import React from "react";
import { CustomCard } from "../../CustomCard";
import { Box, Divider } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyles from "./styles";

const PropertyDetailsComponentSkeleton = ({}) => {
  const styles = useStyles();

  return (
    <CustomCard
      borderRadius="xl"
      borderColor="secondary"
      classes={styles.wrapperPropretyDetails}
    >
      <Box className={styles.containerHeaderDetails}>
        <Skeleton variant="text" width={100} height={40} />
        <Divider className={styles.divider} />
      </Box>
      <Box className={styles.containerInfoDetails}>
        <Box className={styles.containerDataItem}>
          <Skeleton variant="text" width={100} height={25} />
          <Skeleton variant="text" width={100} height={25} />
        </Box>
        <Box className={styles.containerDataItem}>
          <Skeleton variant="text" width={100} height={25} />
          <Skeleton variant="text" width={100} height={25} />
        </Box>
        <Box className={styles.containerDataItem}>
          <Skeleton variant="text" width={100} height={25} />
          <Skeleton variant="text" width={100} height={25} />
        </Box>
        <Box className={styles.containerDataItem}>
          <Skeleton variant="text" width={100} height={25} />
          <Skeleton variant="text" width={100} height={25} />
        </Box>
        <Box className={styles.containerDataItem}>
          <Skeleton variant="text" width={100} height={25} />
          <Skeleton variant="text" width={100} height={25} />
        </Box>
        <Box className={styles.containerDataItem}>
          <Skeleton variant="text" width={100} height={25} />
          <Skeleton variant="text" width={100} height={25} />
        </Box>
        <Box className={styles.containerDataItem}>
          <Skeleton variant="text" width={100} height={25} />
          <Skeleton variant="text" width={100} height={25} />
        </Box>
        <Box className={styles.containerDataItem}>
          <Skeleton variant="text" width={100} height={25} />
          <Skeleton variant="text" width={100} height={25} />
        </Box>
      </Box>
    </CustomCard>
  );
};

export default PropertyDetailsComponentSkeleton;
